import { createRouter, createWebHistory } from 'vue-router'
import type { RouteRecordRaw } from 'vue-router'

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    redirect: '/dashboard'
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/Login.vue'),
    meta: { requiresAuth: false }
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: () => import('@/layouts/MainLayout.vue'),
    meta: { requiresAuth: true },
    children: [
      {
        path: '',
        name: 'DashboardHome',
        component: () => import('@/views/Dashboard.vue')
      },
      {
        path: '/users',
        name: 'Users',
        component: () => import('@/views/Users.vue')
      },
      {
        path: '/audio',
        name: 'Audio',
        component: () => import('@/views/Audio.vue')
      },
      {
        path: '/maps',
        name: 'Maps',
        component: () => import('@/views/Maps.vue')
      },
      {
        path: '/lines',
        name: 'Lines',
        component: () => import('@/views/Lines.vue')
      },
      {
        path: '/settings',
        name: 'Settings',
        component: () => import('@/views/Settings.vue')
      }
    ]
  }
]

const router = createRouter({
  history: createWebHistory(),  // 使用默认路径
  routes
})

// 路由守卫
router.beforeEach((to, from, next) => {
  const isAuthenticated = localStorage.getItem('token')
  
  console.log('路由守卫检查:', {
    to: to.path,
    from: from.path,
    requiresAuth: to.meta.requiresAuth,
    isAuthenticated: !!isAuthenticated,
    token: isAuthenticated ? '存在' : '不存在'
  })
  
  if (to.meta.requiresAuth && !isAuthenticated) {
    console.log('需要认证但未登录，跳转到登录页')
    next('/login')
  } else if (to.path === '/login' && isAuthenticated) {
    console.log('已登录用户访问登录页，跳转到dashboard')
    next('/dashboard')
  } else {
    console.log('路由检查通过，继续导航')
    next()
  }
})

export default router
